var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-index-layout',{attrs:{"title":_vm.$t('inventory.name'),"show-button":false},scopedSlots:_vm._u([{key:"new-button",fn:function(){return undefined},proxy:true}])},[_c('router-view'),_c('InventoryItemIndexTableFilter',{on:{"filter":_vm.filterItems}}),_c('InventoryItemCSV'),_c('InventoryItemIndexTable',{ref:"table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }